import TableFilter from './table-filter'

export default TableFilter



// WEBPACK FOOTER //
// ./src/views/my-components/table-filter/index.js